<template>
  <div>
    <translation keypath="ngp/maintenance_lock/text">
      <template #duration
        ><b>{{ humanDurationToUnlock }}</b></template
      >
    </translation>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { Translation } from "vue-i18n";
import { useMaintenanceStore } from "../../../store/maintenance";

const maintenance = useMaintenanceStore();

const humanDurationToUnlock = computed(() => maintenance.humanDurationToUnlock);
</script>
